export default "__VITE_ASSET__Bsrs1U6W__"